var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
import { asThemeConsumer } from "../../../theme/Theme";
export var DropdownPositionX;
(function (DropdownPositionX) {
    DropdownPositionX["LEFT"] = "left";
    DropdownPositionX["RIGHT"] = "right";
    DropdownPositionX["CENTER"] = "center";
})(DropdownPositionX || (DropdownPositionX = {}));
export var DropdownPositionY;
(function (DropdownPositionY) {
    DropdownPositionY["TOP"] = "top";
    DropdownPositionY["BOTTOM"] = "bottom";
})(DropdownPositionY || (DropdownPositionY = {}));
export var DropdownVariant;
(function (DropdownVariant) {
    DropdownVariant["MENU"] = "menu";
})(DropdownVariant || (DropdownVariant = {}));
var DropdownComp = /** @class */ (function (_super) {
    __extends(DropdownComp, _super);
    function DropdownComp(props) {
        var _this = _super.call(this, props) || this;
        _this.onShow = function (_evt) {
            if (_this.state.dropdownHoverTimeout) {
                clearTimeout(_this.state.dropdownHoverTimeout);
            }
            _this.setState({
                show: true,
            });
        };
        _this.onHide = function (_evt) {
            if (_this.state.dropdownHoverTimeout) {
                clearTimeout(_this.state.dropdownHoverTimeout);
            }
            _this.setState({ dropdownHoverTimeout: setTimeout(function () {
                    _this.setState({
                        show: false,
                    });
                }, 300),
            });
        };
        _this.state = {
            show: false,
            dropdownHoverTimeout: undefined,
        };
        _this.onShow = _this.onShow.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        return _this;
    }
    /**
     *
     */
    DropdownComp.prototype.render = function () {
        var clazzName = joinClasses(this.props.className || "", "scl-o-dropdown__trigger", this.isManual()
            ? (this.props.show === true
                ? "scl-o-dropdown--open" : "scl-o-dropdown--closed") :
            (this.state.show
                ? "scl-o-dropdown--open" : "scl-o-dropdown--closed"));
        /* The variant is Menu by default */
        var currentVariant = this.props.variant === DropdownVariant.MENU
            ? "scl-o-dropdown__menu" : "scl-o-dropdown__menu";
        var classNameDropdown = joinClasses(currentVariant, this.props.positionX
            ? currentVariant + "--" + this.props.positionX : undefined, this.props.positionY
            ? currentVariant + "--" + this.props.positionY : undefined);
        return (React.createElement("div", { className: clazzName, onMouseOver: !this.isManual() ? this.onShow : undefined, onMouseOut: !this.isManual() ? this.onHide : undefined },
            this.props.trigger,
            React.createElement("div", { className: classNameDropdown }, this.props.content)));
    };
    DropdownComp.prototype.isManual = function () {
        return !(this.props.show === undefined || typeof this.props.show === "undefined");
    };
    return DropdownComp;
}(React.Component));
export { DropdownComp };
/**
 *
 */
export var Dropdown = asThemeConsumer(DropdownComp);
